const baseUrl = "Webhook";

export const tiggerRemitaPaymentUrl = (rrr) => `${baseUrl}/remitapayment?rrr=${rrr}`;
